export var types = ['warning', 'error', 'info'];
export var iconSizes = ['small'];
export var defaultAlertTextStyle = {
  textAlign: 'left'
};